export const fmtEUR = (v) => {
  if (v === null || v === undefined || isNaN(v)) return "Non calcolabile";
  const n = new Intl.NumberFormat("it-IT", { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: true }).format(Math.abs(v));
  const parts = n.split(",");
  const intPart = parts[0].replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return `${v < 0 ? "-" : ""}${intPart},${parts[1] || "00"} €`;
};

export const fmtNum = (v) => {
  if (v === null || v === undefined || isNaN(v)) return "—";
  return new Intl.NumberFormat("it-IT").format(v);
};

export const fmtPct = (v) => {
  if (v === null || v === undefined || isNaN(v)) return "Non calcolabile";
  return new Intl.NumberFormat("it-IT", { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(v) + " %";
};

export const fmtDate = (v) => {
  if (!v) return "—";
  try {
    const d = new Date(v);
    if (isNaN(d)) return v;
    return new Intl.DateTimeFormat("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", timeZone: "Europe/Rome" }).format(d);
  } catch { return v; }
};
